"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_rdf_parse_1 = require("@comunica/bus-rdf-parse");

var rdfxml_streaming_parser_1 = require("rdfxml-streaming-parser");
/**
 * A comunica RDF/XML RDF Parse Actor.
 */


var ActorRdfParseRdfXml =
/*#__PURE__*/
function (_bus_rdf_parse_1$Acto) {
  _inherits(ActorRdfParseRdfXml, _bus_rdf_parse_1$Acto);

  function ActorRdfParseRdfXml(args) {
    _classCallCheck(this, ActorRdfParseRdfXml);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorRdfParseRdfXml).call(this, args));
  }

  _createClass(ActorRdfParseRdfXml, [{
    key: "runHandle",
    value: function () {
      var _runHandle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action, mediaType, context) {
        var quads;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                action.input.on('error', function (e) {
                  return quads.emit('error', e);
                });
                quads = action.input.pipe(new rdfxml_streaming_parser_1.RdfXmlParser({
                  baseIRI: action.baseIRI
                }));
                return _context.abrupt("return", {
                  quads: quads,
                  triples: true
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function runHandle(_x, _x2, _x3) {
        return _runHandle.apply(this, arguments);
      }

      return runHandle;
    }()
  }]);

  return ActorRdfParseRdfXml;
}(bus_rdf_parse_1.ActorRdfParseFixedMediaTypes);

exports.ActorRdfParseRdfXml = ActorRdfParseRdfXml;